// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderDetail_container__EBjjA {
  animation: OrderDetail_init__Ooo6J 1s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 30px;
}

/*---Title---*/
.OrderDetail_container__EBjjA .OrderDetail_titleContainer__jHtre {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.OrderDetail_container__EBjjA .OrderDetail_titleContainer__jHtre h4 {
  width: 92%;
  text-align: center;
  font-size: 1.8rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.OrderDetail_container__EBjjA .OrderDetail_titleContainer__jHtre .OrderDetail_arrow__Sa-mU {
  transition: 0.3s;
}

.OrderDetail_container__EBjjA .OrderDetail_titleContainer__jHtre .OrderDetail_arrow__Sa-mU:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.OrderDetail_container__EBjjA .OrderDetail_info__wxIUg {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.OrderDetail_container__EBjjA .OrderDetail_info__wxIUg .OrderDetail_accordion__mG8Ja {
  border-radius: 10px;
}

.OrderDetail_container__EBjjA .OrderDetail_info__wxIUg .OrderDetail_summary__6oWk6 {
  display: flex;
  justify-content: space-between;
  width: 95%;
}

.OrderDetail_container__EBjjA .OrderDetail_info__wxIUg .OrderDetail_summary__6oWk6 .OrderDetail_titleData__GXcZH {
  font-size: 1.2rem;
  font-family: Roboto, sans-serif;
  font-weight: 400;
}

.OrderDetail_container__EBjjA .OrderDetail_info__wxIUg .OrderDetail_information__3jSoy {
  font-size: 1.4rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-top: 20px;
}

/*---Información---*/
.OrderDetail_container__EBjjA .OrderDetail_tableContainer__lmoDV {
  margin-top: 30px;
  border-radius: 5px;
  box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.268);
}

.OrderDetail_loader__3c8TD {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}

@keyframes OrderDetail_init__Ooo6J {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/OrdenesPedido/Detail/OrderDetail.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  margin-top: 30px;\n}\n\n/*---Title---*/\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .titleContainer h4 {\n  width: 92%;\n  text-align: center;\n  font-size: 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .titleContainer .arrow {\n  transition: 0.3s;\n}\n\n.container .titleContainer .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container .info {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.container .info .accordion {\n  border-radius: 10px;\n}\n\n.container .info .summary {\n  display: flex;\n  justify-content: space-between;\n  width: 95%;\n}\n\n.container .info .summary .titleData {\n  font-size: 1.2rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 400;\n}\n\n.container .info .information {\n  font-size: 1.4rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-top: 20px;\n}\n\n/*---Información---*/\n.container .tableContainer {\n  margin-top: 30px;\n  border-radius: 5px;\n  box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.268);\n}\n\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OrderDetail_container__EBjjA`,
	"init": `OrderDetail_init__Ooo6J`,
	"titleContainer": `OrderDetail_titleContainer__jHtre`,
	"arrow": `OrderDetail_arrow__Sa-mU`,
	"info": `OrderDetail_info__wxIUg`,
	"accordion": `OrderDetail_accordion__mG8Ja`,
	"summary": `OrderDetail_summary__6oWk6`,
	"titleData": `OrderDetail_titleData__GXcZH`,
	"information": `OrderDetail_information__3jSoy`,
	"tableContainer": `OrderDetail_tableContainer__lmoDV`,
	"loader": `OrderDetail_loader__3c8TD`
};
export default ___CSS_LOADER_EXPORT___;
